export const OWNER = 'owner'
export const COLLABORATOR = 'collaborator'
export const PENDING_INVITATION = 'Pending invitation*'
export const EXPIRED_INVITATION = 'Invitation expired'
export const SENT = 'sent'
export const COLLAB_INFO =
    'Collaborators can invite new members and upload / delete models.'
export const OWNER_INFO =
    'Owners can edit quotes, invite or remove collaborators, and upload / delete models.'
export const COLLAB_DISPLAY = 'Collaborator'
export const OWNER_DISPLAY = 'Quote owner'
export const MEMBER_TYPE = 'Membership'
export const INVITE_TYPE = 'Invite'
